import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PopupWithForm.css';  // use login css ?
import { CurrentUserContext } from '../../context/CurrentUserContext';

function PopupWithForm({
  isOpen, onClose, name, title, buttonText, onSubmit, isButtonEnabled, isLoggedIn, children, buttonClassName, closeButtonClassName, hideDefaultButton, formClassName, contentClassName
}) {
  const currentUser = React.useContext(CurrentUserContext);
  const location = useLocation();
  
  const isSignIn = location.pathname === '/home';
  const altRoute = isSignIn ? '/upgrade' : '/signin';
//  const altText = isSignIn ? 'Register' : 'Start';

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen]);



  return (
    <section 
      onClick={onClose}
      className={`popup popup_type_${name} ${isOpen ? 'popup_open' : ''}`}>
        <div className={`popup__content${contentClassName ? " " + contentClassName : ""}`}  
          onClick={(e) => e.stopPropagation()} >
          <form   
            className={`popup__form${formClassName ? " " + formClassName : ""}`}        
            name={name} onSubmit={onSubmit}>
            <h3 className="popup__title">{title}</h3>
            {children}
            {!hideDefaultButton && (
              <button type="submit" disabled={!isButtonEnabled} className={`popup__button ${buttonClassName || ''} ${!isButtonEnabled ? 'popup__button_disabled': ''}`}>
                {buttonText}
              </button>
            )}
            <button type="button" className={`popup__close ${closeButtonClassName || ''}`} onClick={onClose}>x</button>
          </form>
        </div>
    </section>
  );
}

export default PopupWithForm;

